import api from '../../utils/axios';

const API_URL = process.env.REACT_APP_API_URL || '';

export interface ConfiguracionSmtp {
  Id?: number;
  Host: string;
  Puerto: number;
  Usuario: string;
  /** Solo se envía al guardar; nunca se devuelve desde el servidor */
  Clave?: string;
  RemitenteName: string;
  RemitenteEmail: string;
  UsarTLS: boolean;
  tieneClave?: boolean;
}

/** Solo los campos que acepta el DTO del backend (sin Id, Activo, fechas, tieneClave) */
export interface GuardarSmtpPayload {
  Host: string;
  Puerto: number;
  Usuario: string;
  Clave: string;
  RemitenteName: string;
  RemitenteEmail: string;
  UsarTLS: boolean;
}

export class EmailApi {
  static async obtenerConfiguracionSmtp(): Promise<ConfiguracionSmtp | null> {
    try {
      const response = await api.get(`${API_URL}/email/configuracion-smtp`);
      return response.data;
    } catch {
      return null;
    }
  }

  static async guardarConfiguracionSmtp(payload: GuardarSmtpPayload): Promise<{ mensaje: string }> {
    const response = await api.post(`${API_URL}/email/configuracion-smtp`, payload);
    return response.data;
  }

  static async probarConexion(): Promise<{ ok: boolean; mensaje: string }> {
    const response = await api.post(`${API_URL}/email/probar-conexion`);
    return response.data;
  }
}
